import React, { useEffect, useRef } from 'react';
import { useMonetization } from '../context/MonetizationContext';

// A single ad placement. `slot` maps to a key in adSlots (header/inContent/inFeed/sidebar/footer).
// Renders a real AdSense unit when ads are enabled AND a client + slot id exist;
// otherwise shows a tasteful labelled placeholder so layout is complete pre-approval.
const AdSlot = ({ slot = 'inContent', format = 'auto', className = '', minH = 120, label = 'Advertisement' }) => {
  const { adsEnabled, adsenseClient, adSlots } = useMonetization();
  const ref = useRef(null);
  const pushed = useRef(false);
  const slotId = adSlots && adSlots[slot];
  const live = adsEnabled && adsenseClient && slotId;

  useEffect(() => {
    if (!live || pushed.current) return;
    try {
      // eslint-disable-next-line no-unused-expressions
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch (e) { /* ignore */ }
  }, [live]);

  if (!adsEnabled) return null;

  return (
    <div className={`w-full ${className}`}>
      <div
        className="relative rounded-xl overflow-hidden bg-[#EFE7D2]/70 border border-dashed border-[#D7BC6D] flex items-center justify-center"
        style={{ minHeight: minH }}
      >
        <span className="absolute top-2 left-3 text-[10px] font-semibold tracking-[0.18em] uppercase text-[#b79b76]">
          {label}
        </span>
        {live ? (
          <ins
            ref={ref}
            className="adsbygoogle"
            style={{ display: 'block', width: '100%' }}
            data-ad-client={adsenseClient}
            data-ad-slot={slotId}
            data-ad-format={format}
            data-full-width-responsive="true"
          />
        ) : (
          <span className="text-[13px] text-[#b79b76] px-4 text-center">Ad space</span>
        )}
      </div>
    </div>
  );
};

export default AdSlot;
